import { formatInTimeZone } from 'date-fns-tz';
import { memo } from 'react';

import { Avatar } from '@/ui/Avatar/Avatar';

import type { CalendarPerson } from '../../types';

import type { EventPopoverContentProps } from './types';

function PersonList({ label, people }: { label: string; people: CalendarPerson[] }) {
  return (
    <div className="flex flex-col gap-1 text-xs opacity-90">
      <span>{label}:</span>
      {people.map((person) => (
        <span key={person.id} className="flex items-center gap-1.5">
          <Avatar src={person.avatarUrl} name={person.name} size="xs" />
          {person.name}
        </span>
      ))}
    </div>
  );
}

function EventPopoverContent({ event, timeZone }: EventPopoverContentProps) {
  const zone = event.timeZone ?? timeZone;
  const timeLabel = event.isAllDay
    ? 'All day'
    : `${formatInTimeZone(event.start, zone, 'h:mm a')} – ${formatInTimeZone(event.end, zone, 'h:mm a')}`;

  return (
    <div className="flex flex-col gap-1">
      <span className="font-semibold">{event.title}</span>
      <span className="text-xs opacity-90">{timeLabel}</span>
      {event.location && <span className="text-xs opacity-90">{event.location}</span>}
      {event.providers && event.providers.length > 0 && (
        <PersonList label="Providers" people={event.providers} />
      )}
      {/* Multiple participants only show in the event details modal, not this tooltip */}
      {event.participants && event.participants.length === 1 && (
        <PersonList label="Participant" people={event.participants} />
      )}
    </div>
  );
}

export default memo(EventPopoverContent);
